import React from "react";
import "./Navbar.scss";
const Navbar = () => {
  return <div className="navbarcont">PODOMORO PARK BANDUNG</div>;
};

export default Navbar;
